import { schema } from "normalizr";

const ctaSchema = new schema.Entity("ctas", { idAttribute: "id" });

export default ctaSchema;



// WEBPACK FOOTER //
// ./src/schemas/cta.js